$(document).ready(function(){
    $('body').on('click', '.quantity-change a', function(e){
        e.preventDefault();
        var q = $(this).closest('.quantity-change').find('input').val();
        if($(this).hasClass('qplus')){
            q = q * 1 + 1;
        }
        else{
            if(q > 1){
                q = q - 1;
            }
        }
        $(this).closest('.quantity-change').find('input').val(q).trigger('change');
    });
    if($('.product-thumbs-slider').length > 0) {
        $('.product-thumbs-slider .slides').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            autoplay: false,
            autoplaySpeed: 5000,
            appendDots: false,
            touchThreshold: 90,
            appendArrows: $('.product-thumbs-slider .navi-muskolo'),
        });
        $('.product-thumbs-slider .item').on('click', function(){
            $('.full-gallery-img').each(function(){
                $(this).hide()
            });
            $('.product-thumbs-slider .item').each(function(){
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            $('.full-gallery-img[data-img-id="'+$(this).attr('data-img')+'"]').fadeIn(500);
        })
    }
    $('.set-filter a').on('click', function(e){
        e.preventDefault();
        $('.price_slider_amount [type="submit"]').click();
    })

    if($('.muskolo-select-trigger').length > 0){
        $('.muskolo-select-trigger').each(function(){
            var selected_item = $(this).next('select').find('option:selected').html();
            $(this).find('.selected-item').html(selected_item);
        });
        $('.muskolo-select-trigger li').on('click', function(){
            $(this).closest('.muskolo-select-trigger').find('li:not(.selected-item)').slideToggle(500);
            $(this).closest('.muskolo-select-trigger').toggleClass('open');
            if(!$(this).hasClass('selected-item')) {
                $(this).closest('.muskolo-select-trigger').next('select').val($(this).attr('data-value')).trigger('change');
            }
            if($(window).width() < 992) {
                setTimeout(function () {
                    if ($('.muskolo-select-trigger').hasClass('open')) {
                        $('body .square-flag').each(function () {
                            $(this).hide();
                        });
                    } else {
                        $('body .square-flag').each(function () {
                            $(this).show();
                        });
                    }
                }, 100)
            }
        });
    }
    if(window.location.hash == '#opened-filters'){
        $('.filters').show();
    }

    $('.filters-trigger .open-filters').on('click', function(e){
        e.preventDefault();
        $('.filters').slideDown(500);
        window.history.pushState('page2', '', '#opened-filters');
    });
    $('.filters .top a, .filters .close-filters').on('click', function(e){
        e.preventDefault();
        $('.filters').slideUp(500);
        window.location.hash = '';
    })
});

jQuery(document).ready(function ($) {
    "use strict";

    $('.single_add_to_cart_button').click(function (e) {
        e.preventDefault();
        $('.single_add_to_cart_button').parent().find('.product-added').slideUp(200);
        var id = $(this).val();
        var data = {
            product_id: id,
            quantity: $(this).closest('.cart').find('.quantity-change input').val()
        };
        $.post(wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), data, function (response) {

            if (!response) {
                return;
            }
            if (response.error) {
                alert("Nie udało się dodać, spróbuj ponownie później");
                $('.custom_add_to_cart').parent().removeClass('loading');
                return;
            }
            if (response) {

                var url = woocommerce_params.wc_ajax_url;
                url = url.replace("%%endpoint%%", "get_refreshed_fragments");
                $.post(url, function (data, status) {
                    $(".woocommerce.widget_shopping_cart").html(data.fragments["div.widget_shopping_cart_content"]);
                    if (data.fragments) {
                        jQuery.each(data.fragments, function (key, value) {

                            jQuery(key).replaceWith(value);
                        });
                    }
                    jQuery("body").trigger("wc_fragments_refreshed");
                });
                // $('header .q').html($('header .q').html() * 1 + parseInt(data['quantity']));
                $('.single_add_to_cart_button').parent().removeClass('loading').find('.product-added').slideDown(500);

            }

        });

    });
});